import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import { THEME_COLOR } from "../../styles/colors";

// Outlined card frame for assistant content: rounded gray outline, 16px inset, optional title.
const OutlineCard = ({ title, spacing = "300", children }) => (
  <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.MIST_GRAY, boxBorderRadiusOutline: 12 }}>
    <Box type="outline" spacingInset="400">
      <Column spacing={spacing}>
        {title && <Text type="h100">{title}</Text>}
        {children}
      </Column>
    </Box>
  </Theme>
);

export default OutlineCard;
